import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Event registration form", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Details you want to collect from visitors.", -1)
const _hoisted_3 = { class: "container" }

import { save, close } from "ionicons/icons";
import {
  IonLabel,
  IonPage,
  IonItem,
  IonList,
  IonGrid,
  IonButton,
  IonLoading,
  IonIcon,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonCol,
  IonFooter,
  IonContent,
  onIonViewDidEnter,
  useIonRouter,
} from "@ionic/vue";
import { useRoute } from "vue-router";
import { handleError, useForm } from "@/views";
import { useContextStore } from "@/stores/context";
import { reactive } from "vue";
import {
  getVisitorFormSettings,
  updateVisitorFormSettings,
} from "@/api/events";
import { useToasters } from "@/composition/toasters";
import { IVisitorFormSettings } from "@/models/event";


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const contextStore = useContextStore();
const router = useIonRouter();
const toasters = useToasters();
const { form_settings } = useForm();
const route = useRoute();
const event_id = parseInt(route.params.event_id as string, 10);

let ogSettings: Partial<IVisitorFormSettings> = {
  phone_number: "v",
  birthdate: "v",
  job_title: "v",
  company: "v",
  country: "v",
};
const state = reactive({
  loading: false,
  form_enabled: true,
});

const submit = async () => {
  state.loading = true;
  if (state.form_enabled) {
    // settings.static_fields = settings.static_fields.map((field) => ({
    //   id: field.id,
    //   title: undefined,
    //   active: field.active,
    // }));
    // const promises = settings.static_fields
    //   .filter((static_field) => static_field.active)
    //   .map((static_field) => updateAttendingField(static_field));
    // state.loading = true;
    // await Promise.all(promises);
    // state.loading = false;
  }

  updateVisitorFormSettings({
    ...form_settings,
    event_id: contextStore.event.id,
  })
    .then(() => {
      toasters.addSuccess("Visitor form update successful!");
      state.loading = false;
    })
    .catch((err) => {
      state.loading = false;
      handleError(err);
    });
};

// getAttendingFields({ event: contextStore.event.id })
//   .then((response) => {
//     const fields = response.data.results;
//     settings.static_fields = fields.map((field) => ({
//       active: false,
//       title: field.title,
//       id: field.id,
//     }));
//     state.loading = false;
//   })
//   .catch((err) => {
//     state.loading = false;
//   });
onIonViewDidEnter(() => {
  state.loading = true;
  getVisitorFormSettings(event_id)
    .then((response) => {
      state.loading = false;
      ogSettings = response.data;
      form_settings.company = ogSettings.company;
      form_settings.country = ogSettings.country;
      form_settings.job_title = ogSettings.job_title;
      form_settings.phone_number = ogSettings.phone_number;
      form_settings.birthdate = ogSettings.birthdate;
    })
    .catch((err) => {
      handleError(err);
      state.loading = false;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("section", null, [
            _createVNode(_unref(IonItem), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), null, {
                  default: _withCtx(() => [
                    _hoisted_1,
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (state.form_enabled)
              ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Phone number")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelect), {
                          placeholder: "Select field use",
                          modelValue: _unref(form_settings).phone_number,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form_settings).phone_number) = $event)),
                          interface: "popover"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSelectOption), { value: "m" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Mandatory")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonSelectOption), { value: "v" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Visible")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Birthdate")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelect), {
                          placeholder: "Select field use",
                          modelValue: _unref(form_settings).birthdate,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form_settings).birthdate) = $event)),
                          interface: "popover"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSelectOption), { value: "m" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Mandatory")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonSelectOption), { value: "v" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Visible")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Country")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelect), {
                          placeholder: "Select field use",
                          modelValue: _unref(form_settings).country,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form_settings).country) = $event)),
                          interface: "popover"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSelectOption), { value: "m" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Mandatory")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonSelectOption), { value: "v" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Visible")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Company")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelect), {
                          placeholder: "Select field use",
                          modelValue: _unref(form_settings).company,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form_settings).company) = $event)),
                          interface: "popover"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSelectOption), { value: "m" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Mandatory")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonSelectOption), { value: "v" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Visible")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Job title")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelect), {
                          value: "v",
                          placeholder: "Select field use",
                          modelValue: _unref(form_settings).job_title,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form_settings).job_title) = $event)),
                          interface: "popover"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSelectOption), { value: "m" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Mandatory")
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonSelectOption), { value: "v" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Visible")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFooter), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("section", null, [
              _createVNode(_unref(IonGrid), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRow), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            expand: "block",
                            color: "light",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).back()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(close)
                              }, null, 8, ["icon"]),
                              _createTextVNode(" Cancel ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            expand: "block",
                            color: "success",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (submit()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(save)
                              }, null, 8, ["icon"]),
                              _createTextVNode(" Save ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonLoading), {
        "is-open": state.loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})